import React from 'react';
import LegalPageLayout, { LegalSection, LegalSubtitle, LegalText, LegalList } from '../../components/LegalPageLayout';

const AvisoLegalPage = () => {
  return (
    <LegalPageLayout
      title="Aviso Legal"
      description="Aviso legal de Web a Bajo Coste. Información sobre términos y condiciones, propiedad intelectual y responsabilidades."
      canonical="https://webabajocoste.es/legal/aviso-legal"
    >
      <LegalSection>
        <LegalSubtitle>1. Información de la empresa</LegalSubtitle>
        <LegalText>
          En cumplimiento de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información 
          y de comercio electrónico, le informamos que el titular de esta web es:
        </LegalText>
        <LegalList>
          <li>Denominación social: Candle Dropstore Sociedad Limitada</li>
          <li>CIF: B19327030</li>
          <li>Domicilio social: Calle Merced 20 1C, Guadalajara 19001, España</li>
          <li>Teléfono: +34 628 774 688</li>
          <li>Email: hola@webabajocoste.es</li>
          <li>Datos registrales: Inscrita en el Registro Mercantil de Guadalajara</li>
          <li>Nombre de dominio: webabajocoste.es</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>2. Condiciones de uso</LegalSubtitle>
        <LegalText>
          El acceso y utilización de esta página web atribuye al visitante la condición de usuario, 
          y supone la aceptación plena y sin reservas por parte del usuario de todas y cada una de las 
          condiciones contenidas en este Aviso Legal.
        </LegalText>
        <LegalText>
          El usuario se compromete a hacer un uso adecuado de los contenidos, servicios, aplicaciones y 
          herramientas que están accesibles en este sitio web, con sujeción a la Ley y a las presentes 
          condiciones de uso.
        </LegalText>
        <LegalText>
          Queda prohibido el uso de esta web con fines ilegales o no autorizados, en particular y sin 
          carácter limitativo:
        </LegalText>
        <LegalList>
          <li>Cualquier forma de violación de los derechos de terceros.</li>
          <li>La realización de acciones que impidan el normal funcionamiento de este sitio web.</li>
          <li>Acceder a datos de terceros o a ciertas áreas restringidas de la web, sin consentimiento expreso.</li>
          <li>Usar la web con fines o efectos ilícitos, ilegales, contrarios a lo establecido en estas condiciones.</li>
          <li>Provocar daños en los sistemas físicos o lógicos del propietario, de sus proveedores o de terceros.</li>
          <li>Introducir o difundir en la red virus informáticos o cualquier otro sistema físico o lógico que sea susceptible de causar daños.</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>3. Propiedad intelectual e industrial</LegalSubtitle>
        <LegalText>
          Todos los contenidos, textos, imágenes, marcas y códigos fuente son propiedad de Candle Dropstore Sociedad Limitada 
          o de terceros a los que se han adquirido sus derechos de explotación, y están protegidos por los derechos de 
          Propiedad Intelectual e Industrial.
        </LegalText>
        <LegalText>
          El usuario únicamente tiene derecho a un uso privado de los mismos, sin ánimo de lucro, y necesita autorización 
          expresa para modificarlos, reproducirlos, explotarlos, distribuirlos o ejercer cualquier derecho perteneciente a su titular.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>4. Limitación de responsabilidad</LegalSubtitle>
        <LegalText>
          La información y servicios incluidos o disponibles a través de las páginas web pueden incluir incorrecciones o errores. 
          Periódicamente se realizan mejoras y/o cambios en esta web. Candle Dropstore Sociedad Limitada no garantiza la disponibilidad 
          y continuidad del funcionamiento del sitio web.
        </LegalText>
        <LegalText>
          Candle Dropstore Sociedad Limitada excluye cualquier responsabilidad por los daños y perjuicios de toda naturaleza que 
          puedan deberse a la falta de disponibilidad o de continuidad del funcionamiento de este sitio web, o a los servicios y 
          contenidos que ofrece.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>5. Legislación aplicable y jurisdicción</LegalSubtitle>
        <LegalText>
          Las presentes condiciones generales se rigen por la legislación española. Para cualquier litigio que pudiera 
          surgir relacionado con el sitio web o la actividad que en él se desarrolla, serán competentes los Juzgados y 
          Tribunales de Guadalajara, renunciando expresamente el usuario a cualquier otro fuero que pudiera corresponderle.
        </LegalText>
      </LegalSection>
      
      <LegalText>
        Fecha de la última actualización: 28 de marzo de 2023
      </LegalText>
    </LegalPageLayout>
  );
};

export default AvisoLegalPage; 